import Component from 'flarum/common/Component';

import getStatusSetting from '../common/util/getStatusSetting';
import addDaysToDate from '../common/util/addDaysToDate';
import InviteCodeDeleteConfirmationModal from './modal/InviteCodeDeleteConfirmationModal';

export default class UserManageInviteCodeListItem extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    const {targetData,mapModule} = this.attrs;
    this.u2diUserType9 = app.forum.attribute('u2diUserType9');
    this.inviteCodeData = targetData;
    this.loading = false;
  }

  view() {
    const inviteCode = this.inviteCodeData.inviteCode();
    const userData = this.inviteCodeData.u2diUserData();
    const realName = this.inviteCodeData.realName();
    const codeType = this.inviteCodeData.codeType();
    const userType = this.inviteCodeData.userType();
    const validDuration = this.inviteCodeData.validDuration();
    const usedAt = this.inviteCodeData.usedAt();
    const statusSetting = getStatusSetting(usedAt?1:0);
    const inviteCodeStatusStyle = statusSetting.statusStyle+";width:45px";

    return (
      <div className="u2diMapSideBarInfoData u2diInfoItemContainer">
        {this.u2diUserType9===true && (
          <div className="u2diUserManageInviteCodeContainer">
            <div style="width: 50%;">
              <div style="font-size:14px;">{inviteCode}</div>
              {codeType===0 && (
                <div style="margin-top: 9px;display: flex;font-size: 12px;color: gray;">
                  <div style="width: 50px;">{realName}</div>
                  <div style="margin-left: 10px;">{app.translator.trans('ziven-u2di.forum.user-type-'+userType)}</div>
                </div>
              )}

              {codeType===1 && userData && (
                <div style="margin-top: 9px;display: flex;font-size: 12px;color: gray;">
                  <div style="width: 50px;">{userData.attribute("u2diUserName")}</div>
                  <div>{app.translator.trans('ziven-u2di.forum.user-type-'+userType)}</div>
                </div>
              )}
            </div>
            <div style="width: 50%;text-align:right">
              <div style="display:inline-block;font-size: 12px;color: gray;">
                {app.translator.trans('ziven-u2di.forum.item-invite-code-type-'+codeType)}
                {app.translator.trans('ziven-u2di.forum.item-invite-code-duration-'+validDuration)}
              </div>
              <div style={inviteCodeStatusStyle} className="u2diUserManagementColumnRoundedItem">
                {app.translator.trans(usedAt?'ziven-u2di.forum.item-invite-code-used':'ziven-u2di.forum.item-invite-code-not-used')}
              </div>
              {usedAt===null && (
                <div style="margin-top: 10px;display: flex;justify-content: flex-end;">
                  <div style="width: 40px;font-size: 12px;color: gray;cursor: pointer;" onclick={(e) => this.deleteInviteCodeConfirmation(e)}>{app.translator.trans('ziven-u2di.lib.delete')}</div>
                </div>
              )}
              {usedAt!==null && (
                <div style="margin-top: 10px;font-size: 12px;color: gray;">
                  {app.translator.trans('ziven-u2di.forum.item-invite-code-used-at',{date:dayjs(addDaysToDate((usedAt.split(" "))[0],0)).format('YYYY年M月D日')})}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }

  deleteInviteCodeConfirmation(){
    const inviteCodeData = this.inviteCodeData;
    app.modal.show(InviteCodeDeleteConfirmationModal,{inviteCodeData});
  }
}